// Parámetros de juego centralizados. Unidades: metros y segundos.
export const CONFIG = {
  path: {
    lanes: 3,
    laneWidth: 1.3,
    thickness: 0.6,
    startPad: 10, // suelo extra detrás del punto de salida
    firstLength: 60, // primer tramo, recto y largo
    safeStart: 30, // metros sin obstáculos al empezar la partida
    safeAfterTurn: 12, // metros sin obstáculos tras cada curva
    endMargin: 10, // metros sin obstáculos antes de cada esquina
    ahead: 170, // metros de camino generados por delante del jugador
    teeChance: 0.18, // probabilidad de cruce en T (solo cuando el camino va "al norte")
  },
  speed: {
    base: 11, // m/s al empezar
    max: 24,
    perMeter: 0.005, // +1 m/s cada 200 m
  },
  // Dificultad «suave» (pensada para jugar con la cámara): más lenta y acelera más despacio.
  softSpeed: {
    base: 8.5,
    max: 16,
    perMeter: 0.0025,
  },
  player: {
    width: 0.8,
    hitWidth: 0.6, // caja de colisión lateral algo más estrecha que el cuerpo: más permisivo
    height: 1.8,
    slideHeight: 0.8,
    laneChangeSpeed: 10, // m/s laterales
    gravity: 32,
    jumpVelocity: 11, // altura máxima ≈ v²/2g ≈ 1.9 m
    fastFallVelocity: -18, // deslizarse en el aire hace caer de golpe
    slideDuration: 0.75,
    jumpBuffer: 0.15, // salto pedido justo antes de aterrizar
  },
  turn: {
    // Metros antes de la esquina en los que se acepta el giro, a velocidad base.
    // Escala con la velocidad para que el tiempo de reacción sea siempre el mismo (~0,45 s).
    window: 5,
    lateGrace: 0.9, // metros pasada la esquina en los que aún se acepta
    cameraAssist: 1.8, // con la cámara la ventana es 1,8 veces más larga (~0,8 s)
    requestHold: 0.6, // segundos que espera un giro pedido con el brazo antes de la ventana
  },
  obstacles: {
    // Probabilidad de que una fila sea un foso corto / un bloqueo largo (crece con la dificultad d).
    pitChance: 0.14, // + 0.08·d
    closureChance: 0.15, // + 0.08·d — columna profunda o foso largo: anula carriles durante un tramo
    pitLength: [2.4, 3.6], // foso saltable (siempre así cuando ocupa los 3 carriles)
    longPitLength: [7, 14], // foso largo: solo en 1–2 carriles, hay que cambiarse de carril
    deepLength: [8, 20], // columna de roca profunda: anula un carril
  },
  score: {
    coinValue: 10,
    multiplierEvery: 350, // metros sin tropezar para subir el multiplicador
    maxMultiplier: 5,
  },
  chaser: {
    farGap: 16, // metros por detrás cuando no hay peligro (fuera de cámara)
    closeGap: 2.6, // metros por detrás tras un tropiezo (se le ve detrás del jugador)
    caughtGap: 1.2,
    startGap: 2.5, // al empezar la partida arranca pegado y se va quedando atrás
    memory: 8, // segundos que se mantiene cerca: un tropiezo dentro de este tiempo = atrapado
    approachSpeed: 9, // m/s relativos al acercarse
    recedeSpeed: 2.5, // m/s relativos al alejarse
  },
  stumble: {
    slowFactor: 0.55, // la velocidad cae a este factor…
    recovery: 1.2, // …y se recupera en estos segundos
    hurtTime: 0.6, // segundos sin nuevas colisiones tras tropezar
  },
  powerUps: {
    every: 260, // de media, un potenciador cada tantos metros
    minDistance: 150, // ninguno antes de estos metros
    weights: { magnet: 0.4, shield: 0.35, sprint: 0.25 },
    magnet: 10, // duración en segundos
    shield: 10,
    sprint: 4,
    sprintMultiplier: 1.7,
    sprintGrace: 1, // invencibilidad extra al acabar el sprint
    magnetRadius: 9,
  },
  camera: {
    fov: 65,
    fovPortrait: 85,
    distance: 6.5,
    height: 3.4,
    lookAhead: 4,
    lookHeight: 1.2,
    lateralFollow: 0.4, // fracción del desplazamiento lateral que sigue la cámara
    yawSmoothing: 7,
    heightSmoothing: 5,
    positionSmoothing: 14,
  },
  sim: {
    step: 1 / 120, // subpaso máximo de física
    maxFrame: 0.1, // evita saltos enormes tras volver de segundo plano
  },
  revive: {
    cost: 100, // monedas; se dobla en cada uso dentro de la misma partida
    max: 3,
    grace: 3, // segundos de invencibilidad al reaparecer
  },
  endDelay: 1.1, // segundos entre morir y mostrar la pantalla final
};

CONFIG.path.width = CONFIG.path.laneWidth * CONFIG.path.lanes;
